module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAsCAMAAAA3k5qAAAAAAXNSR0IB2cksfwAAADlQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAvHZQPQAAABN0Uk5TAChfd4Cwr2cIwGBYGIRoEFd4IAuMxHgAAACeSURBVHic7dTRCsMgDAXQ6NKuZna2/f+PnYNpHEnarhQGY/dRD3iJEADnLyjS9dcBSpy8zwkB2RDeIojgeGeDmKTIpwMbREU8T9mYhI1NqlkhxVgksdEJ4RSLMUgd6Bh6g4Cj+TXnziJt8d2E2j/024SOPvRpl7dO64T+Xb7XxW8TEuScLr9FtHVYE3Gum0RPmvKc9dXcZGk2iRpa4AHtQQp2+RfxOwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/document.png
// module id = 809
// module chunks = 0